<div class="container my-5">
  <div class="card">
    <h1 class="fs-2 fw-bold text-center my-5">
      {{ 'message.login-welcome.' + tenant | translate }}
    </h1>
    <div class="card-body">
      <p class="text-center mb-5">
        {{ 'message.login-headline.' + tenant | translate }}
      </p>
  
      <ng-container [ngSwitch]="tenant">
        <div *ngSwitchCase="'default'" class="mb-5">
          <div class="logos-container d-flex align-items-center justify-content-center mb-2">
            <img
              src="/assets/img/logos/PhaST-Logo.png"
              [alt]="'phast.name' | translate"
              class="me-3"
            />
            <img
              src="/assets/img/logos/leuphana_logo.svg"
              [alt]="'gsat.name' | translate"
            />
          </div>
          <div class="logos-container d-flex align-items-center justify-content-center mb-2">
            <img
              src="/assets/img/logos/GTEBS_Logo.svg"
              [alt]="'tm-wiso.name' | translate"
              class="me-3"
            />
            <img
              src="/assets/img/logos/ITB-BUSINESS_Logo.svg"
              [alt]="'itb-business.name' | translate"
            />
          </div>
          <div class="logos-container d-flex align-items-center justify-content-center mb-2">
            <img
              src="/assets/img/logos/ITB-SCIENCE_Logo.svg"
              [alt]="'itb-science.name' | translate"
              class="me-3"
            />
            <img
              src="/assets/img/logos/ITB-TECHNOLOGY_Logo.svg"
              [alt]="'itb-technology.name' | translate"
            />
          </div>
        </div>
        <div
          class="logos-container d-flex align-items-center justify-content-center mb-2"
          *ngSwitchCase="'sdv'"
        >
          <img
            src="/assets/img/logos/sdv-logo-sw.png"
            [alt]="'title.sdv.logo' | translate"
            class="me-3"
          />
        </div>
      </ng-container>
      <div class="form-container d-flex flex-column">
        <button
          (click)="login()"
          class="btn btn-primary"
        >
          {{ 'label.login' | translate }}
        </button>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="button-spacer or-divider">
          <div class="w-100 d-flex justify-content-center">
            <div>{{ 'label.or' | translate }}</div>
          </div>
        </div>
  
        <ng-container *ngIf="enableMbr">
          <button
            (click)="login()"
            class="btn btn-outline-primary mbr-login-button"
          >
            <img src="/assets/img/mbr/Logo-Quadrat-NBP_web.jpg" alt="" role="presentation" />
            {{ 'label.login-mbr' | translate }}
          </button>
  
          <div fxLayout="row" fxLayoutAlign="space-between center" class="button-spacer or-divider">
            <div class="w-100 d-flex justify-content-center">
              <div>{{ 'label.or' | translate }}</div>
            </div>
          </div>
        </ng-container>
  
        <button
          (click)="inviteDialog()"
          class="btn btn-outline-primary"
        >
          {{ 'label.register' | translate }}
        </button>
      </div>
      <div class="password-link-container">
        <a
          (click)="
            $event.preventDefault(); forgotPasswordDialog()
          "
          href=""
        >
          {{ 'label.forgot-password' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
